import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const NotificationPanel = ({ notifications }) => {
  const [expandedId, setExpandedId] = useState(null);

  const getNotificationIcon = (type) => {
    const icons = {
      'application': 'FileText',
      'interview': 'Calendar',
      'deadline': 'AlertCircle',
      'system': 'Bell',
      'message': 'MessageSquare'
    };
    return icons?.[type] || 'Bell';
  };

  const getNotificationColor = (type) => {
    const colors = {
      'application': 'var(--color-primary)',
      'interview': 'var(--color-success)',
      'deadline': 'var(--color-warning)',
      'system': 'var(--color-accent)',
      'message': 'var(--color-secondary)'
    };
    return colors?.[type] || 'var(--color-muted-foreground)';
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffMinutes = Math.floor(diffTime / (1000 * 60));
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffMinutes < 60) return `${diffMinutes}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-warm-sm">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg md:text-xl font-heading font-semibold text-card-foreground">
            Notifications
          </h3>
          <button className="text-sm text-primary hover:text-primary/80 transition-smooth">
            Mark all read
          </button>
        </div>
      </div>
      <div className="max-h-[500px] overflow-y-auto">
        {notifications?.map((notification) => (
          <div 
            key={notification?.id}
            className={`p-4 border-b border-border last:border-b-0 hover:bg-muted/50 transition-smooth cursor-pointer ${
              !notification?.read ? 'bg-primary/5' : ''
            }`}
            onClick={() => toggleExpand(notification?.id)}
          >
            <div className="flex gap-3">
              <div 
                className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: `${getNotificationColor(notification?.type)}15` }}
              >
                <Icon 
                  name={getNotificationIcon(notification?.type)} 
                  size={20} 
                  color={getNotificationColor(notification?.type)} 
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h4 className="text-sm font-medium text-card-foreground line-clamp-1">
                    {notification?.title}
                  </h4>
                  {!notification?.read && (
                    <span className="w-2 h-2 rounded-full bg-accent flex-shrink-0 mt-1" />
                  )}
                </div>

                <p className={`text-sm text-muted-foreground mb-2 ${
                  expandedId === notification?.id ? '' : 'line-clamp-2'
                }`}>
                  {notification?.message}
                </p>

                <div className="flex items-center justify-between">
                  <span className="text-xs text-muted-foreground">
                    {formatTime(notification?.timestamp)}
                  </span>
                  {notification?.actionLabel && (
                    <button className="text-xs text-primary hover:text-primary/80 transition-smooth">
                      {notification?.actionLabel}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 border-t border-border">
        <button className="w-full text-sm text-primary hover:text-primary/80 transition-smooth font-medium">
          View All Notifications
        </button>
      </div>
    </div>
  );
};

export default NotificationPanel;